import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=2be9680f&scoped=true&"
var script = {}
import style0 from "./tools.vue?vue&type=style&index=0&id=2be9680f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9680f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be9680f')) {
      api.createRecord('2be9680f', component.options)
    } else {
      api.reload('2be9680f', component.options)
    }
    module.hot.accept("./tools.vue?vue&type=template&id=2be9680f&scoped=true&", function () {
      api.rerender('2be9680f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/tools.vue"
export default component.exports